import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import useHttp from "../../../../../hooks/useHttp";

import { hideModal } from "../../../../../store/slices/modal";
import { DISPUTES_OTHER_PARTY_RESPONSE_URL } from "../../../../../utils/api-ends";
import LoaderImg from "../../../../../assets/media/loader.gif";
import { withdrawListValue } from "../../../../../store/slices/withdraw";
import store from "../../../../../store";
import { canSeeDisputButtonValue, singleDisputObjValue } from "../../../../../store/slices/Dispute";


const DeliveryImage = ({ modalData }) => {
  const dispatch = useDispatch();
  const closeModal = () => dispatch(hideModal());
  const disputeData = useSelector((state) => state.DeliveryImage);



  return (
    <div className="col-xl-6 col-lg-8 col-md-10">
      <div className="load-add-edit-modal">
        <img className="modal-progress-image-style" src={disputeData.deliveryImage} />
        <div className="multiple-btn modal-button ">
          <button onClick={closeModal}> Cancel </button>
        </div>
      </div>
    </div>
  );
};

export default DeliveryImage;
